





$(document).on('click', '.avatar_small .item', function(e) {
  const $this = $(this);

  // Tìm cụm cha (nếu không có .avatar_group sẽ fallback lên closest parent)
  let $group = $this.closest('.avatar_group');
  if ($group.length === 0) {
    // nếu không có class .avatar_group, tìm parent gần nhất chứa cả avatar_small và avatar_big
    $group = $this.parents().has('.avatar_small').has('.avatar_big').first();
  }

  // Lấy class small-# (hỗ trợ small-1, small-01, small-a ... nếu muốn)
  const classes = $this.attr('class') || '';
  const m = classes.match(/small-([^\s]+)/);
  if (!m) {
    console.warn('Không tìm thấy class dạng small-X trên item:', $this[0]);
    return;
  }
  const avatarNumber = m[1];

  // Nếu không tìm thấy cụm hợp lệ thì cố tìm .avatar_big liền kề trong DOM
  if (!$group || $group.length === 0) {
    console.warn('Không tìm thấy avatar_group tương ứng. Hành động sẽ giới hạn trong document.');
    // fallback: chỉ thao tác trên siblings gần nhất
    $('.avatar_small .item').removeClass('active');
    $('.avatar_big .item').removeClass('active');
    $this.addClass('active');
    $('.avatar_big .big-' + avatarNumber).addClass('active');
    return;
  }

  // Xóa active chỉ trong cụm này
  $group.find('.avatar_small .item').removeClass('active');
  $group.find('.avatar_big .item').removeClass('active');

  // Thêm active cho item được click và item tương ứng trong cụm
  $this.addClass('active');

  // tìm avatar_big tương ứng
  const $big = $group.find('.avatar_big .big-' + avatarNumber);
  if ($big.length === 0) {
    console.warn('Không tìm thấy .avatar_big .big-' + avatarNumber + ' trong cùng cụm:', $group[0]);
  } else {
    $big.addClass('active');
  }
});

document.querySelectorAll('.tabs').forEach(tabs => {
  const tabBtns = tabs.querySelectorAll('.tab-btn');
  const tabContents = tabs.querySelectorAll('.tab-content');

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
console.log("btn");
      // reset active
      tabBtns.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      // thêm active vào cái đang click
      btn.classList.add('active');
      const tabId = btn.dataset.tab;
      tabs.querySelector(`.tab-content[data-tab="${tabId}"]`).classList.add('active');
    });
  });
});

// Swiper initialization for weapon detail images
document.addEventListener('DOMContentLoaded', function() {
  // Initialize weapon swiper
  // const weaponSwiper = new Swiper('.weapon-swiper', {
  //   // Responsive breakpoints
  //   breakpoints: {
  //     // Mobile: 1 slide visible
  //     0: {
  //       slidesPerView: 1,
  //       spaceBetween: 20,
  //     },
  //     // Desktop: 2.5 slides visible
  //     769: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 20,
  //     }
  //   },
    
  //   // Pagination dots
  //   pagination: {
  //     el: '.swiper-pagination',
  //     clickable: true,
  //   },
    
  //   touchRatio: 1,
  //   touchAngle: 45,
  //   grabCursor: true,
    
  //   // Keyboard support
  //   keyboard: {
  //     enabled: true,
  //   },
    
  //   // Mouse wheel support
  //   mousewheel: {
  //     invert: false,
  //   },
    
  //   // Speed of transition
  //   speed: 300,
    
  //   // Effect
  //   effect: 'slide',
    
  //   // Initialize callback
  //   on: {
  //     init: function () {
  //       console.log('Weapon swiper initialized');
  //     },
  //     slideChange: function () {
  //       console.log('Slide changed to:', this.activeIndex);
  //     }
  //   }
  // });
//  const weaponSwiper = new Swiper(".weapon-swiper", {
//          breakpoints: {
//       // Mobile: 1 slide visible
//       0: {
//         slidesPerView: 1,
//         spaceBetween: 20,
//       },
//       // Desktop: 2.5 slides visible
//       769: {
//         slidesPerView: 2.5,
//         spaceBetween: 20,
//       }
//     },
    
//     // Pagination dots
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },
    
//     touchRatio: 1,
//     touchAngle: 45,
//     grabCursor: true,
//     });
});